import { BigNumber } from "ethers";
import { formatUnits } from "utils/number";

export const useDecimalToken = (tokens = []) => ({
  data: tokens.reduce((acc, token) => {
    acc[token.address] = formatUnits(BigNumber.from(token.decimals), 0);
    return acc;
  }, {}),
});
